import { render, staticRenderFns } from "./ShoppingListButton.vue?vue&type=template&id=9829398c&scoped=true"
import script from "./ShoppingListButton.vue?vue&type=script&lang=js"
export * from "./ShoppingListButton.vue?vue&type=script&lang=js"
import style0 from "./ShoppingListButton.vue?vue&type=style&index=0&id=9829398c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9829398c",
  null
  
)

export default component.exports